module.exports = __webpack_public_path__ + "img/map-hrs-table-backup-bg.8d005dc8.png";